<template>
  <div class="RunningTimeBox"
    v-loading="$store.state.user.loadingState">
    <div class="selectTime">
      <div class="setTimeBox">
        <div class="setChangeTime">
          <p>设置正常运行时间：</p>
          <el-time-select placeholder="起始时间"
            v-model="startTime"
            :picker-options="{
              start: '00:00',
              step: '01:00',
              end: '24:00',
            }"
            size="small"
            @change="endTime = ''">
          </el-time-select>
          <el-time-select placeholder="结束时间"
            v-model="endTime"
            :picker-options="{
              start: '00:00',
              step: '01:00',
              end: '24:00',
              minTime: startTime,
            }"
            size="small">
          </el-time-select>
          <el-select v-model="typeValue"
            style="width: 10%; margin-left: 10px"
            size="small">
            <el-option key="1"
              label="单次"
              value="单次"> </el-option>
            <el-option key="2"
              label="重复"
              value="重复"> </el-option>
          </el-select>
          <template v-if="typeValue == '单次'"><el-date-picker v-model="singleTime"
              type="date"
              placeholder="选择日期"
              size="small"
              style="margin-right: 20px; width: 17%"
              :picker-options="pickerOptions"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd">
            </el-date-picker></template>
          <template v-else>
            <el-select v-model="repeatValue"
              multiple
              collapse-tags
              style="width: 17%; margin-right: 20px"
              placeholder="请选择"
              size="small">
              <el-option v-for="item in repeatOptions"
                :key="item.name"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>
          </template>
          <el-button type="primary"
            size="small"
            @click="addActiveTime"
            :loading="showAdd">添加</el-button>
        </div>
        <el-button type="primary"
          plain
          size="small"
          @click="dialogVisible = true">历史查询</el-button>
      </div>

      <div class="showActiveTime">
        <div class="tabRoll">
          <template v-if="tags.length">
            <el-tag v-for="(v, i) in tags"
              :key="i"
              :closable="v.status == 2 || v.status == 3"
              @close="handleClose(v)"
              style="margin: 0 5px 10px 0">
              {{ v.name }}
            </el-tag>
          </template>
          <template v-else>
            <p>未设置运行时间</p>
          </template>
        </div>
      </div>
    </div>
    <div class="chartsBox">
      <RunningTimeCharts :id="'mycharts'"
        :chartsData="chartsData" />
    </div>
    <el-dialog title="历史查询"
      :visible.sync="dialogVisible"
      width="50%"
      append-to-body
      v-if="dialogVisible">
      <RunningTimeHistory :activeItem="activeItem" />
    </el-dialog>
  </div>
</template>

<script>
import RunningTimeCharts from "@/components/shebeiguanli/RunningTimeCharts.vue";
import RunningTimeHistory from "@/components/shebeiguanli/RunningTimeHistory.vue";
import { dateFtt } from "@/assets/js/utils";
import api from "@/api";
export default {
  props: ["activeItem"],
  components: {
    RunningTimeCharts,
    RunningTimeHistory,
  },
  data() {
    return {
      dialogVisible: false,
      startTime: "",
      endTime: "",
      singleTime: "",
      typeValue: "单次",
      repeatValue: [],
      repeatOptions: [
        { name: "周日" },
        { name: "周一" },
        { name: "周二" },
        { name: "周三" },
        { name: "周四" },
        { name: "周五" },
        { name: "周六" },
      ],
      tags: [],
      chartsData: {},
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      showAdd: false,
    };
  },
  methods: {
    async addActiveTime() {
      if (this.startTime && this.endTime) {
        if (this.typeValue == "单次") {
          if (!this.singleTime) {
            this.$message.error("未设置日期!");
            return false;
          }
          if (
            this.singleTime == dateFtt("yyyy-MM-dd", new Date()) &&
            this.endTime <= dateFtt("hh:mm", new Date())
          ) {
            this.$message.error("结束时间不能早于当前时间");
            return false;
          }
        } else {
          if (this.repeatValue.length == 0) {
            this.$message.error("未设置日期!");
            return false;
          }
          this.repeatValue.sort((a, b) => {
            let week = {
              周一: 0,
              周二: 1,
              周三: 2,
              周四: 3,
              周五: 4,
              周六: 5,
              周日: 6,
            };
            return week[a] - week[b];
          });
        }
        this.showAdd = true;
        let res = await api.setNormalRuntime({
          deviceId: this.activeItem.deviceId
            ? this.activeItem.deviceId
            : this.activeItem.id.id,
          beginTs: this.startTime,
          endTs: this.endTime,
          type: this.typeValue == "单次" ? 0 : 1,
          status: 0,
          settingDate: this.typeValue == "单次" ? this.singleTime : "",
          range: this.typeValue == "单次" ? "" : this.repeatValue.join(";"),
          createTime: new Date().getTime(),
        });
        if (res && res.data.code == 200) {
          this.showAdd = false;
          this.$message.success("添加成功!");
          this.getTimeList();
          this.getRunTimeCharts();
        }
      } else {
        this.$message.error("请选择开始时间和结束时间");
      }
    },
    handleClose(item) {
      this.$confirm("此操作将永久删除该条设置, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return new Promise(async (resolve) => {
            let res = await api.deleteNormalRuntime({
              deviceId: this.activeItem.deviceId
                ? this.activeItem.deviceId
                : this.activeItem.id.id,
              id: item.id,
              projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
                .projects[0].projectId,
            });
            if (res && res.data.code == 200) {
              this.$message.success("删除成功!");
              setTimeout(() => {
                this.getTimeList();
                this.getRunTimeCharts();
              }, 500);
            }
            resolve();
          });
        })
        .catch(() => {});
    },
    async getTimeList() {
      this.tags = [];
      this.$store.commit("SET_LOADING", true);
      let res = await api.getSetRuntimeList({
        deviceId: this.activeItem.deviceId
          ? this.activeItem.deviceId
          : this.activeItem.id.id,
        date: dateFtt("yyyy-MM-dd", new Date()),
      });
      if (res && res.data.code == 200) {
        this.$store.commit("SET_LOADING", false);
        res.data.data.forEach((v) => {
          let str = "";
          if (v.type == 0) {
            str = `${v.beginTs}-${v.endTs} 单次 ${v.settingDate}`;
          } else {
            let arr = v.range.split(";");
            str = `${v.beginTs}-${v.endTs} 重复 ${
              arr.length == 7 ? "每天" : arr.join("、")
            }`;
          }
          str +=
            v.status == 1
              ? "(已删除)"
              : v.status == 4
              ? "(已过期)"
              : v.status == 5
              ? "(部分生效)"
              : "";
          this.tags.push({ name: str, status: v.status, id: v.id });
        });
      }
    },
    async getRunTimeCharts() {
      this.chartsData = {
        xData: [],
        data: [],
      };
      let res = await api.getSetRuntimeCharts({
        deviceId: this.activeItem.deviceId
          ? this.activeItem.deviceId
          : this.activeItem.id.id,
        entityType: "DEVICE",
        interval: 3600,
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        key: "RunSign",
        date: dateFtt("yyyy-MM-dd", new Date()),
      });
      if (res && res.data.code == 200) {
        res.data.data.forEach((v) => {
          this.chartsData.xData.push(dateFtt("hh:mm", new Date(v.time)));
          let item = null;
          switch (v.status) {
            case 0:
              item = v.runTime;
              break;
            case 1:
              item = {
                value: v.runTime,
                itemStyle: {
                  color: {
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "rgba(254, 174, 162, 1)",
                      },
                      {
                        offset: 0.7,
                        color: "rgba(253, 114, 112, 1)",
                      },
                    ],
                    globalCoord: false,
                  },
                },
              };
              break;
            case 2:
              item = {
                value: v.runTime,
                itemStyle: {
                  color: {
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "rgba(135,163,210,.2)",
                      },
                      {
                        offset: 1,
                        color: "rgba(135,163,210,.4)",
                      },
                    ],
                    globalCoord: false,
                  },
                },
              };
              break;
          }
          this.chartsData.data.push(item);
        });
      }
    },
  },
  mounted() {
    this.getTimeList();
    this.getRunTimeCharts();
  },
};
</script>

<style lang="scss" scoped>
.RunningTimeBox {
  width: 96%;
  height: 100%;
  margin: 0 auto;
  .selectTime {
    width: 100%;
    height: 25%;
    .setTimeBox {
      width: 100%;
      height: 60px;
      @include setFlexBetween;
      .setChangeTime {
        width: 100%;
        height: 100%;
        @include setFlexStart;
        ::v-deep .el-date-editor.el-input,
        .el-date-editor.el-input__inner {
          width: 15%;
        }
      }
    }

    .showActiveTime {
      width: 100%;
      height: calc(100% - 62px);
      background: #f3f7ff;
      border-radius: 10px;
      @include setFlexCenter;
      .tabRoll {
        width: 95%;
        height: 80%;
        overflow: auto;
        p {
          text-align: center;
          line-height: 70px;
          color: #999;
        }
      }
    }
  }
  .chartsBox {
    height: 74%;
    width: 100%;
  }
}
</style>